<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2023 by Christina Dunbar-Hester</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2023</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">32 31 30 29 28 27 26 25 24 23     1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-81969-3 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-81971-6 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-81970-9 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226819709.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226819709.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Dunbar-Hester, Christina, 1976–, author.</p>
<p class="cip">Title: Oil beach : how toxic infrastructure threatens life in the ports of Los Angeles and beyond / Christina Dunbar-Hester.</p>
<p class="cip">Other titles: How toxic infrastructure threatens life in the ports of Los Angeles and beyond</p>
<p class="cip">Description: Chicago ; Illinois : The University of Chicago Press, 2023. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2022021784 | ISBN 9780226819693 (cloth) | ISBN 9780226819716 (paperback) | ISBN 9780226819709 (ebook)</p>
<p class="cip">Subjects: LCSH: Environmental sciences—California—San Pedro Bay (Bay) | Ecology—California—San Pedro Bay (Bay) | Environmentalism—California—San Pedro Bay (Bay) | Container terminals—Environmental aspects—California—San Pedro Bay (Bay) | Infrastructure (Economics)—Environmental aspects—California—San Pedro Bay (Bay) | Capitalism—Environmental aspects—California—San Pedro Bay (Bay) | San Pedro Bay (Calif. : Bay)—History. | BISAC: NATURE / Environmental Conservation &amp; Protection | BUSINESS &amp; ECONOMICS / Infrastructure</p>
<p class="cip">Classification: LCC GE155.C2 D86 2023 | DDC 333.91/70979493—dc23/eng20220723</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2022021784" target="_blank">https://lccn.loc.gov/2022021784</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-dunbar-hester-0004.vue?c326db4a